module.exports = __webpack_public_path__ + "img/C561.c3ef39e5.jpg";